import { doorClient, ImResponse } from '.';

export interface BuyerCenterCartAmount {
  amount: number;
  currencyCode: string;
}

export interface BuyerCenterProduct {
  id: string;
  title: string;
  vendor: string;
  untranslatedTitle: string;
  url: string;
  type: string;
}

export interface BuyerCenterCartImage {
  src: string;
}

export interface BuyerCenterMerchandise {
  id: string;
  price: BuyerCenterCartAmount;
  product: BuyerCenterProduct;
  image: BuyerCenterCartImage;
  sku: string;
  title: string;
  untranslatedTitle: string;
}

export interface BuyerCenterCartLine {
  cost: { totalAmount: BuyerCenterCartAmount };
  merchandise: BuyerCenterMerchandise;
  quantity: number;
}

export interface BuyerCenterCart {
  id: string;
  cost: { totalAmount: BuyerCenterCartAmount };
  lines: BuyerCenterCartLine[];
  totalQuantity: number;
}

export interface BuyerCenterPageViewed {
  title: string;
  href: string;
  timestamp: string;
}

export interface BuyerCenterFootprintData {
  cart: BuyerCenterCart;
  pageViewed: BuyerCenterPageViewed[];
}

export interface GetBuyerFootprintByStoreIdRequest {
  storeId: number;
  sgNewClientId: string;
}

export const getBuyerFootprint = (body: GetBuyerFootprintByStoreIdRequest, signal?: AbortSignal) =>
  doorClient.post<ImResponse<BuyerCenterFootprintData>>(
    '/aggregation/v1/getBuyerFootprintByStoreId',
    body,
    { signal },
  );
